import React from "react";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardLayout from "../../components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../components/Navbars/DashboardNavbar";
import Footer from "../../components/Footer";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import { useSnackbar } from "../../context/SnackbarContext/SnackbarContext";
import ProgressiveBonusesBoard from "./components/ProgressiveBonusesBoard";
import ProgressiveBonusesEditorForm from "./components/ProgressiveBonusesEditorForm";
import useProgressiveBonuses from "./useProgressiveBonuses";
import "./progressiveBonuses.css";

function ProgressiveBonusesEditor() {
  const { bonuses, error, isLoading, loadBonuses, saveBonuses } = useProgressiveBonuses();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (values, actions) => {
    try {
      await saveBonuses(values);
      showSnackbar("Progressive Bonuses", "Bonuses updated successfully.", "notifications", "success");
    } catch (requestError) {
      const message = requestError.response?.data?.message || "Unable to save progressive bonuses.";
      showSnackbar("Progressive Bonuses", message, "cancel", "warning");
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={3} display="flex" justifyContent="space-between" alignItems="center">
        <div>
          <MDTypography variant="h4">Progressive Bonuses</MDTypography>
          <MDTypography variant="body2">Update the live bonus board and Quad of the Day.</MDTypography>
        </div>
        <MDButton
          component="a"
          className="progressive-bonuses-editor__open-display"
          href="/progressive-bonuses/display"
          target="_blank"
          rel="noreferrer"
          variant="outlined"
          color="secondary"
        >
          Open projection
        </MDButton>
      </MDBox>

      {isLoading ? (
        <Card><MDBox p={8} display="flex" justifyContent="center"><CircularProgress color="secondary" /></MDBox></Card>
      ) : error ? (
        <Card>
          <MDBox p={4} textAlign="center">
            <MDTypography variant="body2" mb={2}>{error}</MDTypography>
            <MDButton variant="gradient" color="secondary" type="button" onClick={() => loadBonuses()}>
              Try again
            </MDButton>
          </MDBox>
        </Card>
      ) : (
        <div className="progressive-bonuses-editor__layout">
          <Card className="progressive-bonuses-editor__card">
            <ProgressiveBonusesEditorForm bonuses={bonuses} onSubmit={handleSubmit} />
          </Card>
          <div className="progressive-bonuses-editor__preview">
            <p>Approved artwork · 1536 × 1024</p>
            <ProgressiveBonusesBoard bonuses={bonuses} />
          </div>
        </div>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default ProgressiveBonusesEditor;
